var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "v-datepicker--panel__header" },
        [
          _c("v-col", { attrs: { span: _vm.isRange ? 12 : 24 } }, [
            _vm._v(
              " " +
                _vm._s(_vm.isRange ? _vm._("Start time") : _vm._("时间")) +
                " "
            ),
          ]),
          _vm.isRange
            ? _c("v-col", { attrs: { span: 12 } }, [
                _vm._v(_vm._s(_vm._("End time"))),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass: "v-timepicker__wrapper",
              attrs: { span: _vm.isRange ? 12 : 24 },
            },
            [
              _c("time-panel", {
                attrs: {
                  format: _vm.format,
                  minuteInterval: _vm.minuteInterval,
                  secondInterval: _vm.secondInterval,
                  time: _vm.startTime,
                  min: _vm.minTime,
                  max: _vm.maxTime,
                },
                on: { change: _vm.changeTime },
              }),
            ],
            1
          ),
          _vm.isRange
            ? _c(
                "v-col",
                { staticClass: "v-timepicker__wrapper", attrs: { span: 12 } },
                [
                  _c("time-panel", {
                    attrs: {
                      format: _vm.format,
                      minuteInterval: _vm.minuteInterval,
                      secondInterval: _vm.secondInterval,
                      time: _vm.endTime,
                      min: _vm.endMinTime,
                      max: _vm.endMaxTime,
                    },
                    on: { change: _vm.changeEndTime },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }